export default __webpack_public_path__ + "static/media/crash.076b3723.jpg";